import React, { useState, createContext, useContext } from 'react';
export type AppMode = 'club-loyalty' | 'loyalty-only';
interface AppModeContextType {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
  isLoyaltyOnly: boolean;
}
const AppModeContext = createContext<AppModeContextType | undefined>(undefined);
export function AppModeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [mode, setMode] = useState<AppMode>('club-loyalty');
  const value: AppModeContextType = {
    mode,
    setMode,
    isLoyaltyOnly: mode === 'loyalty-only'
  };
  return <AppModeContext.Provider value={value} data-id="element-6353" data-mp="33lsnh4aw566d">{children}</AppModeContext.Provider>;
}
export function useAppMode() {
  const context = useContext(AppModeContext);
  if (context === undefined) {
    throw new Error('useAppMode must be used within an AppModeProvider');
  }
  return context;
}